// 设置默认网页title
const name = '全联中小学图书信息平台';
module.exports = {
  name
};